<template>
  <div class="save-customisation-component p-3">
    <h5>Save for later</h5>
    <p>By giving your configuration a name and clicking save you can revisit this configuration at a later date or start a new configuration without lising this progress.</p>

    <div class="mb-3">
      <div class="position-relative form-floating">
        <input v-model="name" id="nickname" type="text" class="form-control" placeholder="Nickname" :disabled="loading">

        <label for="nickname">Nickname</label>
      </div>

      <small v-if="preloadSaved" class="text-muted mt-2 d-block">This customisation has already been saved. You may rename it.</small>
    </div>

    <button @click="save()" type="button" class="btn btn-secondary d-flex w-100 justify-content-between align-items-center" :disabled="loading">{{ btnText }} <i class="fak fa-customise"></i></button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      name: null,
      btnText: 'Save customisation',
      saved: false,
    };
  },

  props: {
    preloadSaved: {
      type: Boolean,
      default: false,
    },
    preloadName: {
      type: String,
      default: null,
    },
  },

  watch: {
    //
  },

  created() {
    this.saved = this.preloadSaved

    if (this.saved) {
      this.name = this.preloadName;
      this.btnText = 'Saved';
    }
  },

  methods: {
    save() {
      if (this.loading) {
        return;
      }

      this.loading = true;

      // save the name to the window for other redeye tracking
      window.customisationName = this.name;

      // fire custom event for RedEye data
      const event = new CustomEvent('saved-customisation-event', { detail: { name: this.name } });
      dispatchEvent(event);

      axios.post(window.api_url + '/customiser/save', {
        name: this.name,
      })
      .then(res => {
        if (res.data && res.data.success) {
          notyf.success("Your customisation has successfully been saved.");
          this.btnText = 'Saved';
          this.saved = true;
        }
      })
      .catch(err => {
        //
      })
      .finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>
